import type { IconProps } from '@carboncopyco/icons';
import {
  AreaColoredIcon,
  AreaSpineColoredIcon,
  BarColoredIcon,
  DonutColoredIcon,
  LineColoredIcon,
  MultiLineChartIcon,
  PieColoredIcon,
  ScatterChartIcon,
} from '@carboncopyco/icons';
import type React from 'react';
import type { TemplateIconName } from './types';

export interface CustomChartIconProps extends IconProps {
  name: TemplateIconName;
}

const iconNameToComponent: Record<
  TemplateIconName,
  React.FunctionComponent<IconProps>
> = {
  barColored: BarColoredIcon,
  lineColored: LineColoredIcon,
  pieColored: PieColoredIcon,
  donutColored: DonutColoredIcon,
  areaSpineColored: AreaSpineColoredIcon,
  areaColored: AreaColoredIcon,
  multiLineChart: MultiLineChartIcon,
  scatterChart: ScatterChartIcon,

  barChart: BarColoredIcon,
  lineChart: LineColoredIcon,
  pieChart: PieColoredIcon,
};

export const CustomChartIcon = ({ name, ...props }: CustomChartIconProps) => {
  const Icon = iconNameToComponent[name];

  return Icon ? <Icon {...props} /> : null;
};
